/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/23
 * @updateTime 2021/8/23
 * @decription 预览补充担保入口js
 */
// 表单布局
import acLayoutForm from '@/components/app/layout/form/index.vue';
import {typeDbfs, dbxxcclxType} from "@/filters";
import {Dialog} from "vant";
// 请求js
import request from './mixins/request.js';
export default {
    data() {
        return {
            // 数据列表
            dataList: [],
            // 线上已存在的担保信息
            dbxx: [],
            // 未提交的补充担保信息
            unsubmitDbxx: [],
            // 担保总价值
            dbzjz: 0,
            // 保全id
            bqid: this.$route.query.bqid,
            // 申请人姓名
            source: JSON.parse(this.$route.query.source || '{}'),
            // 模式 1 补充担保 2 变更担保
            mode: this.$route.query.mode,
            // 是否生成=》补充担保表单
            isShow: false,
            // 编辑信息项数据
            editItem: null,
            // 编辑数据的原始数据
            originItem: null,
            // 担保机构显示数据
            bxgsShowDataList: [],
            // 是否可以渲染
            canRender: false
        };
    },
    // 计算属性
    computed: {
        // 是否补充担保模式
        bcdbFlag() {
            return this.mode === '1';
        }
    },
    // 混入
    mixins: [request],
    components: {
        acLayoutForm,
        // 补充担保信息表单组件
        AppSupplementDBXX: () => import('./supplement-DBXX/index.vue'),
        // 变更担保
        appModifyDBXX: () => import('./modify-BGDB/index.vue')
    },
    methods: {
        // 返回
        back() {
            history.go(-1);
        },
        showSupplement: function () {
            // 初始化担保机构数据列表
            this.updateBxgsDataList();
            // 显示补充担保表单
            this.isShow = true;
        },

        /**
         * 取消补充担保
         * @param {Object} formData 取消之前表单的数据
         * @returns {void}
         * */
        cancelSupplement(formData) {
            // 之前的文件列表
            let _beforeFiles = [];
            // 如果是编辑数据
            if (this.editItem && this.editItem.isAdd) {
                _beforeFiles = this.editItem.tBqSqcls;
                // 更新对应的上传文件
                this.updateFiles(_beforeFiles, formData.tBqSqcls, 'cSqclid', this.editItem.cId);
            }
            // 隐藏补充担保保单
            this.hideSupplement();
        },

        /**
         * 更新变更担保相关文件
         * @param {Array<Object>} beforeFiles 之前的材料列表
         * @param {Array<Object>} afterFiles 之后的材料列表
         * @param {String} 材料id对应的key
         * @param {String} dbid 担保id
         * @returns {void}
         * */
        updateFiles(beforeFiles, afterFiles, clIdKey, dbid) {
            const _beforeFilesMap = {};
            beforeFiles.forEach(file => {
                _beforeFilesMap[file[clIdKey]] = file;
            });
            const _afterFilesMap = {};
            afterFiles.forEach(file => {
                _afterFilesMap[file.id] = file;
            });
            const _updateIds = [];
            // 之前的文件如果被删除了，则需要将其新增回来
            beforeFiles.forEach(file => {
                if (!_afterFilesMap[file[clIdKey]]) {
                    // 进行新增
                    _updateIds.push(file[clIdKey]);
                }
            });
            // 如果存在删除的材料id
            if (_updateIds.length) {
                // 请求更新上传材料状态
                this.requestScclStatus(this.bqid, dbid, _updateIds).then(() => {
                    console.log('保全状态更新完成');
                }).catch(err => {
                    console.log(err);
                });
            }
            // 如果是新增的文件，需要将其删除
            afterFiles.forEach(file => {
                if (!_beforeFilesMap[file[clIdKey]]) {
                    // 进行删除
                    this.requestBgDelSccl({
                        // 请求id
                        id: file[clIdKey],
                        // 材料类型
                        cllx: '4'
                    }).then(() => {
                        console.log('删除成功！');
                    }).catch(err => {
                        console.log(err);
                    });
                }
            });
        },

        /**
         * 取消变更担保
         * @param {Object} formData 取消之前的表单数据
         * @returns {void}
         * */
        cancelModify(formData) {
            // 更新相关文件
            this.updateFiles(this.editItem.relatedFiles, formData.relatedFiles, 'id', this.editItem.bGhid);
            // 更新变更担保申请书文件
            this.updateFiles(this.editItem.applicationFiles, formData.applicationFiles, 'id', this.editItem.bGhid);
            // 隐藏补充担保保单
            this.hideSupplement();
        },

        /**
         * 隐藏补充担保信息保单
         * @returns {void}
         * */
        hideSupplement() {
            // 重置编辑信息项数据
            this.editItem = null;
            // 编辑索引还原
            this.editIndex = -1;
            // 原始数据赋值为null
            this.originItem = null;
            // 隐藏补充担保表单
            this.isShow = false;
        },
        /**
         * 获取担保物名称
         * */
        getDbwmc: function (dataItem) {
            switch (Number(dataItem.cDbfs)) {
                case 1:
                    return "保证金";
                case 2:
                    return dataItem.cDbwmc;
                case 3:
                case 4:
                    return dbxxcclxType(dataItem.cCclx);
                case 5:
                    return '诉讼保全责任保险';
            }
        },
        /**
         * 格式化数据
         * @param {Object} dataItem 数据信息项
         * @returns {Object} 转化之后的数据信息项
         * */
        formatData(dataItem) {
            // 如果是变更担保，并且是非编辑状态则需要重置一些信息项
            if (!this.bcdbFlag && !dataItem.isEdit) {
                // 变更担保原因置空
                dataItem.cSqbgyy = '';
                // 变更担保事项类型
                dataItem.nBgsxlx = 2;
            }
            return {
                ...dataItem,
                // 担保方式文本
                dbfsText: dataItem.dbfsText ? dataItem.dbfsText : typeDbfs(dataItem.cDbfs),
                // 担保物名称
                cDbwmcText: this.getDbwmc(dataItem),
                // 担保说明文本
                cDbsmText: this.dbxxValue(dataItem),
                // 担保价值 元
                nDbjzText: isNaN(dataItem.nDbjz) ? '--' : Number(dataItem.nDbjz).toFixed(2)
            };
        },

        /**
         * 重置编辑数据
         * @returns {void}
         * */
        resetEdit() {
            // 重置编辑数据
            this.editItem = null;
            // 重置编辑索引
            this.editIndex = -1;
        },

        /**
         * 保存变更担保信息项数据
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        saveBGDBItemData(formData) {
            // 请求保存变更担保
            this.requestSaveBGDB(this.bqid, formData).then(() => {
                console.log('成功保存变更担保数据！');
            }).catch(err => {
                console.log('保存变更失败：', err);
            });
        },

        /**
         * 保存信息项数据
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        saveItemData(formData) {
            const _formData = this.formatData(formData);
            // editItem存在则说明是更新
            if (this.editItem) {
                // 更新
                this.dataList.splice(this.editIndex, 1, _formData);
                // 如果是变更担保，则需要进行保存，pc上因为有预览的功能，所以此处跟pc保持一致吧
                if (!this.bcdbFlag) {
                    // 保存变更担保
                    this.saveBGDBItemData(_formData);
                }
            } else {
                // 数据列表添加，考虑在第一个里面进行插入，方便新增的时候找到对应的新增信息项
                this.dataList.unshift(_formData);
            }
            // 更新担保总价值
            this.updateDbzjz();
            // 隐藏表单
            this.hideSupplement();
        },
        // 财产/担保说明
        dbxxValue(item) {
            // 如果是担保方式是担保机构
            if (item.cDbfs === '5') {
                return item.nSysbuy === 1 ? `${item.cBxgsmc} 保单号：${item.cBdh}` : `${item.cBxgsmc}`
            } else {
                return item.cDbsm
            }
        },

        /**
         * 初始化不需要更新的数据
         * @returns {void}
         * */
        initNoUpdateData() {
            // 编辑数据的索引
            this.editIndex = -1;
            // 系统自动关联的担保机构数据列表
            this.bxgsDataList = [];
            // 原始的数据列表
            this.orginalDataList = [];
        },

        /**
         * 更新担保总价值
         * @returns {void}
         * */
        updateDbzjz() {
            let _dbzjz = 0;
            this.dataList.forEach(dataItem => {
                // 担保价值
                _dbzjz += (isNaN(dataItem.nDbjz) || !dataItem.nDbjz) ? 0 : parseFloat(dataItem.nDbjz);
            });
            this.dbzjz = _dbzjz;
        },

        /**
         * 初始化担保信息
         * @returns {void}
         * */
        initDbxx() {
            // 请求补充担保数据列表信息
            this.requestDataList(this.bqid).then(res => {
                let dbxx = res.data;
                const _dataList = [];
                let _dbzjz = 0;
                dbxx.forEach(item => {
                    // 担保价值
                    _dbzjz += (isNaN(item.nDbjz) || !item.nDbjz) ? 0 : parseFloat(item.nDbjz);
                    // 数据列表新增
                    _dataList.push(this.formatData(item));
                });
                this.dbzjz = _dbzjz;
                this.dataList = _dataList;
                // 如果是变更担保，需要保留原始的数据列表，因为变更为减少担保的时候 所有信息项都需要进行还原
                !this.bcdbFlag && (this.orginalDataList = _dataList.slice(0));
                // 担保机构完整数据
                this.updateBxgsCompleteDataList();
            });
        },

        /**
         * 初始化保全责任险数据列表
         * @returns {void}
         * */
        initBqzrxDataList() {
            // 请求保险公司责任险
            this.requestBqzrx(this.bqid).then(data => {
                this.bxgsDataList = data;
                // 担保机构完整数据
                this.updateBxgsCompleteDataList();
            });
        },

        /**
         * 是否系统关联担保
         * @param {Object} dataItem 数据信息项
         * @returns {Boolean} 是否
         * */
        isSysBuy(dataItem) {
            return dataItem.cDbfs === '5' && dataItem.nSysbuy === 1;
        },

        /**
         * 获取当前保单号
         * @returns {Array<String>} 保单号数组
         * */
        getCurrentBdhs() {
            // 保全号
            const _bdhs = [];
            // 排除的保单号
            let _excludeBdh = '';
            if (this.editItem && this.isSysBuy(this.editItem)) {
                _excludeBdh = this.editItem.cBdh;
            }
            this.dataList.forEach(dataItem => {
                // 保险公司诉责险，并且是系统关联担保
                if (this.isSysBuy(dataItem) && dataItem.cBdh !== _excludeBdh) {
                    _bdhs.push(dataItem.cBdh);
                }
            });
            return _bdhs;
        },

        /**
         * 更新担保机构数据列表
         * @returns {void}
         * */
        updateBxgsDataList() {
            // 担保机构数据没有，则显示的担保机构数据为空
            if (!this.bxgsDataList.length) {
                this.bxgsShowDataList = [];
                return;
            }
            const _results = [];
            // 保单号
            const _bdhs = this.getCurrentBdhs();
            // 遍历担保机构，遍历保单号
            this.bxgsDataList && this.bxgsDataList.length && this.bxgsDataList.forEach(dataItem => {
                const _bxgsItem = {
                    // 担保机构id
                    id: dataItem.id,
                    // 担保机构名称
                    name: dataItem.name,
                    // 担保信息
                    dbJbxxs: []
                };
                // 担保基本信息遍历
                dataItem.dbJbxxs.forEach(dbJbxxItem => {
                    if(_bdhs.indexOf(dbJbxxItem.cBdh) === -1) {
                        _bxgsItem.dbJbxxs.push(dbJbxxItem);
                    }
                });
                if (_bxgsItem.dbJbxxs.length) {
                    _results.push(_bxgsItem);
                }
            });
            this.bxgsShowDataList = _results;
        },

        /**
         * 获取担保机构全集数据
         * @returns {void}
         * */
        updateBxgsCompleteDataList() {
            // 补充担保，则是接口获取的数据
            if (this.bcdbFlag) {
                return;
            }
            // 担保机构数据不存在或者没有数据列表
            if (!this.bxgsDataList.length || !this.dataList.length) {
                return;
            }
            // 接口中的担保机构map数据
            const bxgsMapData = {};
            this.bxgsDataList.forEach(dataItem => {
                bxgsMapData[dataItem.id] = dataItem;
            });
            // 倒序遍历
            for (let i = this.dataList.length - 1; i >= 0; i--) {
                const dataItem = this.dataList[i];
                // 如果是自动关联的保险公司诉责险，则需要补充到数据列表中
                if (this.isSysBuy(dataItem)) {
                    // 保险公司数据信息项
                    let _bxgsDataItem = bxgsMapData[dataItem.cBxgs];
                    if (_bxgsDataItem) {
                        _bxgsDataItem.dbJbxxs.unshift({...dataItem});
                    } else {
                        // 添加到map中
                        bxgsMapData[dataItem.cBxgs] = {
                            // 保险公司id
                            id: dataItem.cBxgs,
                            // 保险公司名称
                            name: dataItem.cBxgsmc,
                            dbJbxxs: [
                                {
                                    ...dataItem
                                }
                            ]
                        };
                        // 在前面加入对应的保险公司
                        this.bxgsDataList.unshift(bxgsMapData[dataItem.cBxgs]);
                    }
                }
            }
        },

        /**
         * 获取未提交的数据列表
         * @returns {Array<Object>}
         * */
        getUnSubmitData() {
            const _data = [];
            this.dataList.forEach(item => {
                if (item.isAdd) {
                    _data.push(item);
                }
            })
            return _data;
        },

        /**
         * 获取修改的数据
         * @returns {Array<Object>}
         * */
        getModifiedData() {
            const _data = [];
            this.dataList.forEach(item => {
                if (item.isEdit) {
                    _data.push(item);
                }
            })
            return _data;
        },

        /**
         * 点击了编辑按钮
         * @param {Object} dataItem 当前编辑的信息项
         * @param {Number} index 当前编辑的索引
         * @returns {void}
         * */
        async eClickEdit(dataItem, index) {
            // 如果是变更担保
            if (!this.bcdbFlag) {
                // 如果是变更担保，需要传原始数据
                this.originItem = this.orginalDataList[index];
                // 是否可以申请减少担保
                dataItem.noReduce = this.isSysBuy(this.originItem);
                // 如果当没有编辑过，则需要重置对应的数据
                if (!dataItem.isEdit) {
                    // 赋值上传材料
                    const scclRes = await this.requestSccls(dataItem.bGhid);
                    // 相关材料
                    dataItem.relatedFiles = scclRes.data.tBqSqcls;
                    // 变更申请书
                    dataItem.applicationFiles = scclRes.data.sqfjs;
                }
            }
            // 编辑信息项赋值为当前信息项
            this.editItem = dataItem;
            // 编辑索引
            this.editIndex = index;
            // 显示对应的补充担保信息表单
            this.showSupplement();
        },

        /**
         * 点击了删除按钮
         * @param {Object} dataIte 当前删除的信息项
         * @returns {void}
         * */
        eClickDel(dataItem, index) {
            // 删除
            Dialog.confirm({
                title: '提示',
                message: '删除担保信息后，对应的担保材料会一并删除, 确认删除吗?',
                confirmButtonColor: '#ffffff',
                cancelButtonColor: '#ffffff'
            }).then(() => {
                // 删除对应的信息项
                this.dataList.splice(index, 1);
                // 更新担保价值
                this.updateDbzjz();
            }).catch(() => {
            });
        },

        /**
         * 获取上传材料
         * */
        getSccl(id) {
            return new Promise((resolve, reject) => {
                this.requestSccls(id).then(res => {
                    resolve(res.data.tBqSqcls);
                }).catch(() => {
                    reject();
                })
            })
        },

        /**
         * 点击了查看按钮
         * @param {Object} dataIte 当前查看的信息项
         * @returns {void}
         * */
        async eClickView(dataItem) {
            // 如果不存在上传列表，则需要请求
            if (!dataItem.tBqSqcls) {
                // 赋值上传材料
                dataItem.tBqSqcls = await this.getSccl(dataItem.cId);
            }
            this.editItem = dataItem;
            // 显示补充担保
            this.showSupplement();
        },

        /**
         * 变更担保信息
         * @returns {void}
         * */
        submitBGDBXX() {
            const postData = {
                jbxxs: this.getModifiedData()
            };
            // 如果没有新增，提示没有补充的担保信息
            if (!postData.jbxxs.length) {
                this.$notify({
                    message: '没有变更的担保信息',
                    type: 'warning'
                });
                return;
            }
            // 请求变更担保
            this.requestSubmitBGDB(this.bqid, postData).then((res) => {
                if (res.code === 200) {
                    // 返回我的申请页面
                    this.$router.push({
                        path: '/home/myPreservation'
                    });
                } else {
                    this.$notify(res.message);
                }
            })
                .catch(error => {
                    console.log(error)
                });
        },

        /**
         * 提交补充担保信息
         * */
        submitBCDBXX: function () {
            const postData = {
                jbxxs: this.getUnSubmitData()
            }
            // 如果没有新增，提示没有补充的担保信息
            if (!postData.jbxxs.length) {
                this.$notify({
                    message: '没有补充的担保信息',
                    type: 'warning'
                });
                return;
            }
            this.$axios.post("ssbq/api/bqsqs/bcdb?bqid=" + this.bqid, postData)
                .then(() => {
                    // 返回我的申请页面
                    this.$router.push({
                        path: '/home/myPreservation'
                    });
                });
        },

        /**
         * 点击提交
         * @returns {void}
         * */
        eClickSubmit() {
            // 如果模式是补充担保，则调用补充担保的信息
            if (this.bcdbFlag) {
                this.submitBCDBXX();
            } else {
                // 否则变更担保
                this.submitBGDBXX();
            }
        },

        /**
         * 删除补充担保上传材料
         * @param {Array<Object>} data 变动的数据
         * @returns {Promise}
         * */
        deleteAllChangedSccl(data) {
            return new Promise((resolve, reject) => {
                const ids = [];
                data.forEach(item => {
                    ids.push(this.bcdbFlag ? item.cId : item.bGhid);
                });
                this.requestBatchDelSccl(ids).then(() => {
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            })
        },

        /**
         * 点击了取消按钮
         * @returns {void}
         * */
        eClickCancel() {
            // 获取新增的担保数据
            const postData = this.bcdbFlag ? this.getUnSubmitData() : this.getModifiedData();
            if (!postData.length) {
                this.$router.go(-1);
                return;
            }
            // 补充担保
            Dialog.confirm({
                title: '提示',
                message: this.bcdbFlag ? '您的补充担保申请尚未提交，下次补充时需要重新填写变更信息，确认要退出吗？' : '您的变更担保申请尚未提交，下次变更时需要重新填写变更信息，确认要退出吗？',
                confirmButtonColor: '#ffffff',
                cancelButtonColor: '#ffffff'
            }).then(() => {
                // 删除对应的材料
                this.deleteAllChangedSccl(postData).then(() => {
                    this.$router.go(-1);
                }).catch(() => {
                    this.$notify('取消失败');
                });
            }).catch(() => {
                console.log('取消');
            });
        }
    },
    created() {
        // 初始化不需要更新的数据
        this.initNoUpdateData();
        // 初始化担保信息
        this.initDbxx();
        // 初始化系统自动关联的保险公司数据列表
        this.initBqzrxDataList();
    },
    //进入该页面时，刷新页面，要不上传会导致页面刷新
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if(from.name == 'myPreservation'){
                // 如果是从保全列表过来的需要刷新下页面，否则在手机上上传会有问题
                window.location.reload();
            }
            // 可以进行渲染
            vm.canRender = true;
        });
    }
}
